import { collection, getCountFromServer, query, where } from "firebase/firestore";
import Failure from "../../../core/Failure";
import HttpClient from "../../../core/HttpClient";
import { FirestoreCollections, firestore } from "../../../firebase.config";

async function getUserDetailStats(
  userUid: string
): Promise<{
  notificationsCount: number;
  contactsCount: number;
}> {
  try {
    const db = firestore;
    const contactsCollection = collection(db, FirestoreCollections.contacts);

    // Notifications does not store owner, algolia hit is saved with contact.ownher
    const notifications = await HttpClient.get(
      `/algolia/search/frontend/notifications/view?collaboratorId=${userUid}&countsOnly=true`
    );

    const contactsQuery = query(contactsCollection, where('contact.owner', '==', userUid))
    const contactsSnapshot = await getCountFromServer(contactsQuery);

    return {
      notificationsCount: notifications?.nbHits ?? 0,
      contactsCount: contactsSnapshot.data().count ?? 0
    };
  } catch (e) {
    console.log("error: ", e);
    throw new GetUserDetailStatsFailure();
  }
}

export class GetUserDetailStatsFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default getUserDetailStats;
